export const PageRoutes = {
  Home: "/",
  Dashboard: "/",
  Games: "/games",
  Login: "/login",
  Game: "/game/:id",
  GameViewDetail: "/game-view-detail/:id",
  NLPSeach: "/nlp-search",
  SettingBumperVideo: "/setting/bumper-video",
  SettingPersonalizedChannel: "/setting/personalized-channel",
  BumperVideo: "/setting/bumper-video/:id",
  Audience: "/audience",
};
export const APIRoutes = {
  Login: "/v1/login",
  GetGames: "/v1/get-games",
  GetAllVideoClips: "/v1/search",
  GetGamesAll: "/v1/get-all-games",
  SwitchTenant: "/v1/switch",
  GetSeasons: "/seasons",

  PurgeGame: "/v1/purge-game",
  PurgeCDN: "/v1/purge-cdn",

  GetBumpers: "/v1/get-all-bumper-video",
  RefreshToken: "/v1/refresh-token",
  GetTenant: "/v1/user-tenants",
  GetGameEvents: "/v1/game-events",
  GetGameDetails: "/game-details/:id",
  GetAllTeams: "/v1/get-all-teams",
  GetAllPlayers: "/v1/get-all-players",
  GetBumpersByID: "/v1/get-bumper-video/:id",
  GetNLPSeacrh: "/v1/search-nlp",
  CreateBumper: "/v1/create-bumper-video",
  EditBumper: "/v1/update-bumper-video/:id",
  ActiveInActiveDelete: "/v1/active-inactive-delete-bumper-video/:id",
  GenarateThumbnails: "/v1/generate-thumbnail-by-events",
  AddGameEvent: "/v1/import-game-event",
  UpdateGameEvent: "/v1/game-event/:id",
  GetAggregateStats: "/v1/aggregate-stats-across-schemas",
  GetErrors: "/v1/errors-across-schemas",
};
